export default "/images/bandphoto-2.jpg?f50e766c11a3285300fb60c7afbe0f1d";